import { get } from './httpClient';

export async function getUserByEmail(email, setUser, project) {
	const data = await get(`/users?search=${email}&Nit=${project}`);
	setUser(data.items[0]);
}

export async function getUserIDByEmail(email, setUserID, project) {
	const data = await get(`/users?search=${email}&Nit=${project}`);
	setUserID(data.items[0].UserID);
}

export async function getUserIDByEmailnReturn(email, project) {
	const data = await get(`/users?search=${email}&Nit=${project}`);
	return data.items[0].UserID;
}

export async function getRoleNameByID(id, project) {
	const data = await get(`/roles?roleID=${id}`);
	return data.items[0].nombreRole;
}

export async function getProjectNameByID(id) {
	const data = await get(`/projects?Nit=${id}`);
	return data.items[0].ProjectName;
}

export async function getRoleIDByName(name, project) {
	const data = await get(`/roles?nombreRole=${name}`);
	return data.items[0].roleID;
}

export async function getRolesNamesArray(project) {
	const data = await get(`/roles`);
	const array = data.items
		.filter((item) => item.active === true)
		.map((item) => item.nombreRole);

	if (array.length === 0) {
		array.push('No hay roles activos');
	}

	return array;
}

export async function getUserPermissionsByUserEmail(
	email,
	projectID,
	moduleName
) {
	//
	const userID = await getUserIDByEmailnReturn(email, projectID);
	//
	const projectsRolesUsers = await get(
		`/projectsRolesUsers?userID=${userID}`
	);
	//
	const roleid = projectsRolesUsers.items[0].RoleID;
	const role = await get(`/roles?roleID=${roleid}`);
	//
	//
	const modules = role.items[0].modules;

	const modulo = modules?.[moduleName];

	return modulo;
}

export async function getAllPermissions(email, projectID) {
	//
	const userID = await getUserIDByEmailnReturn(email, projectID);
	//
	const projectsRolesUsers = await get(
		`/projectsRolesUsers?userID=${userID}`
	);
	//
	const roleid = projectsRolesUsers.items[0].RoleID;
	const role = await get(`/roles?roleID=${roleid}&Nit=1`);
	//
	//
	const modules = role.items[0].modules;
	

	return modules;
}
